import { Skeleton } from '@/components/ui/skeleton';
import { BrandMark } from './brand-mark';
import { ContentSkeleton } from './content-skeleton';

const NAV_ROWS = [0, 1, 2, 3, 4, 5];

/**
 * The boot screen, drawn with the shell's real geometry.
 *
 * The sidebar and the panel land on their final coordinates before the session
 * resolves, so the first real render swaps content in without moving anything.
 */
export function ShellSkeleton() {
  return (
    <div className="flex h-full w-full overflow-hidden bg-canvas" aria-busy>
      <div className="hidden w-[232px] shrink-0 flex-col gap-2 bg-sidebar p-2 md:flex">
        <div className="flex h-8 items-center">
          <BrandMark />
        </div>
        <Skeleton className="h-8 w-full" />
        <div className="mt-2 flex flex-col gap-1.5">
          {NAV_ROWS.map((row) => (
            <Skeleton key={row} className="h-8 w-full" />
          ))}
        </div>
        <div className="flex-1" />
        <Skeleton className="h-12 w-full" />
      </div>

      <main className="m-2 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-border bg-background md:ml-0">
        <ContentSkeleton />
      </main>
    </div>
  );
}
